export type Identity = string | number;

export enum UserRole {
  Admin = 'Admin',
  Operator = 'Operator',
}

export enum UserStatus {
  Active = 'Active',
  Inactive = 'Inactive',
}

export type UserAccount = {
  id: Identity;
  username: string;
  name: string;
  createdAt: Date;
  updatedAt: Date | null;
  rolesId: string[];
  roles: [UserRole];
};

export type Credential = {
  accessToken: string;
  refreshToken: string;
  expiration?: string;
};
